export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkPricing: "nav-link-pricing",
  linkTestimonials: "nav-link-testimonials",
  linkContact: "nav-link-contact",
  callBtn: "nav-call-btn",
};

export const HERO = {
  callBtn: "hero-call-btn",
  inspectionBtn: "hero-inspection-btn",
  badgeSpanish: "hero-badge-spanish",
  badgeLicensed: "hero-badge-licensed",
  badgeLocal: "hero-badge-local",
};

export const SERVICES = {
  card: (id) => `service-card-${id}`,
};

export const PRICING = {
  quarterlyCta: "pricing-quarterly-cta",
  oneTimeCta: "pricing-onetime-cta",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  serviceType: "contact-service-type",
  message: "contact-message",
  submit: "contact-submit",
  successAlert: "contact-success",
  phoneLink: "contact-phone-link",
  emailLink: "contact-email-link",
};
